import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import "./ForgetPassword.css";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address."
      )
      .required("Email ID is required."),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    setErrorMessage("");
    setSuccessMessage("");
    try {
      const response = await fetch(`${config.API_BASE_URL}${config.OTP_SEND_ENDPOINT}?email=${encodeURIComponent(values.email)}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        setSuccessMessage("An OTP/Token has been sent to your email.");
        setTimeout(() => {
          navigate("/forget-password-one", { state: { email: values.email } });
        }, 1500);
      } else {
        const errorData = await response.json();
        setErrorMessage(errorData.message || "Failed to send reset link.");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      setErrorMessage("Network error. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className='forget-password-container'>
      <div className='forget-password-box'>
        <div>
          <div style={{ fontSize: "24px", fontWeight: "600", marginBottom: "20px" }}>Forget Password</div>
        </div>
        
        {successMessage && <div style={{ color: "green", marginBottom: "10px" }}>{successMessage}</div>}
        {errorMessage && <div style={{ color: "red", marginBottom: "10px" }}>{errorMessage}</div>}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className='forget-password-form'>
              <div className='input-group'>
                <label>Email ID</label>
                <Field type='email' name='email' placeholder='Enter your email address' />
                <ErrorMessage name='email' component='div' className='error' />
              </div>

              <button
                type='submit'
                disabled={isSubmitting}
                className='submit-button'
              >
                {isSubmitting ? "Sending..." : "Submit"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ForgetPassword;
